import SearchBar from "@/vuetify_custom/v-form";
import { VBtn, VIcon } from "vuetify/lib";
import { getEnumConfigListApi } from "@/views/blogger/sku/service.js";
import SelectedFields from "@/views/blogger/records/components/SelectedFields.jsx";
import {
  localstoragekey,
  noHandleArray,
} from "@/views/blogger/records/constatns.js";
import { put_in_types } from "../../fields";
import styles from "../style.module.less";
import NumberRange from "@/views/blogger/records/components/NumberRange.vue";
const getLocalStorage = () => {
  return (
    JSON.parse(JSON.stringify(localStorage.getItem(localstoragekey))) || []
  );
};
import { publish_form_list } from "../../fields";
export default {
  data() {
    return {
      params: {
        placing_type: null,
        platform: null,
        team_id: null,
        sku_id: null,
        docking_customer_id: null,
        tags: null,
        query_all: false,
        search: null,
        publish_at_start: null,
        publish_at_end: null,
        closed: 0,
        have_payable: 0,
        have_paid: 0,
        delayed: false,
        first_week_like_num_begin: null,
        first_week_like_num_end: null,
        first_week_comment_num_begin: null,
        first_week_comment_num_end: null,
        first_week_favorite_num_begin: null,
        first_week_favorite_num_end: null,
        first_week_view_num_begin: null,
        first_week_view_num_end: null,
        estimate_publish_at_start: null,
        estimate_publish_at_end: null,
        appraised: null,
        publish_form: null,
      },
      content_types: [],
      platform: [],
      selected: getLocalStorage(),
      people_portrait_list: [],
    };
  },
  computed: {
    search_fields() {
      return [
        {
          label: "投放类型",
          type: "select_field",
          key: "placing_type",
          "item-text": "label",
          "item-value": "value",
          cols: 1,
          clearable: true,
          items: put_in_types,
          change: this.search,
        },
        {
          label: "投放平台",
          key: "platform",
          type: "autocompletes",
          "item-text": "enum_value",
          "item-value": "enum_value",
          items: this.platform,
          cols: 1,
          clearable: true,
          change: this.search,
        },
        {
          label: "项目组",
          key: "team_id",
          type: "team_select",
          cols: 1,
          clearable: true,
          change: this.search,
        },
        {
          label: "创建人",
          key: "docking_customer_id",
          type: "autocompletes_async_v1",
          "item-value": "id",
          "item-text": "account",
          api: this.$util.api.customer_select_search,
          cols: 1,
          handle_data: ({ customers }) => {
            return customers;
          },
          clearable: true,
          change: this.search,
        },

        {
          label: "付款状态",
          key: "have_paid",
          type: "autocompletes",
          "item-text": "label",
          "item-value": "value",
          items: [
            { label: "全部", value: 0 },
            { label: "有付款进度", value: true },
            { label: "无付款进度", value: false },
          ],
          cols: 1,
          change: this.search,
        },
        {
          label: "消耗状态",
          key: "have_payable",
          type: "autocompletes",

          "item-text": "label",
          "item-value": "value",
          items: [
            { label: "全部", value: 0 },
            { label: "已实际消耗", value: true },
            { label: "未实际消耗", value: false },
          ],
          cols: 1,
          change: this.search,
        },
        {
          label: "投放状态",
          key: "closed",
          type: "autocompletes",
          "item-text": "label",
          "item-value": "value",
          items: [
            { label: "全部", value: 0 },
            { label: "已完成", value: true },
            { label: "未完成", value: false },
          ],
          cols: 1,
          change: this.search,
        },
        {
          label: "投放SKU",
          key: "sku_id",
          // initList: this.defaultApply,
          // out_params: {
          //     formal: true,
          // },
          type: "autocompletes_async_v1",
          "item-value": "id",
          "item-text": "full_name",
          api: this.$util.api.placing_ads_sku_list,
          clearable: true,
          cols: 3,
          //  rules: [commonValidateRuleGo],
          handle_data: (a) => a,
          change: this.search,
          multiple: true,
        },
        {
          label: "未提账单",
          type: "checkbox",
          key: "not_consume",
          cols: 2,
          click: this.search,
        },
        {
          label: "是否脱稿",
          type: "checkbox",
          key: "delayed",
          cols: 2,
          click: this.search,
        },
        {
          label: "内容类别",
          key: "tags",
          type: "autocompletes",
          multiple: true,
          "item-text": "enum_value",
          "item-value": "enum_value",
          items: this.content_types,
          cols: 2,
          clearable: true,
          change: this.search,
        },

        {
          label: "发布时间",
          type: "date_range",
          key: "put_date_",
          prependIcon: "",
          start_key: "publish_at_start",
          end_key: "publish_at_end",
          cols: 2,
          clearable: true,
          "click:clear": this.search,
          inputTwo: this.search,
        },
        {
          label: "预计发布时间",
          type: "date_range",
          key: "estimate_publish",
          prependIcon: "",
          start_key: "estimate_publish_at_start",
          end_key: "estimate_publish_at_end",
          cols: 2,
          clearable: true,
          "click:clear": this.search,
          inputTwo: this.search,
        },

        {
          label: "7天点赞",
          key: "7_up",
          cols: 2,
        },
        {
          label: "7天评论",
          key: "7_comment",
          cols: 2,
        },
        {
          label: "7天收藏",
          key: "7_favorite",
          cols: 2,
        },
        {
          label: "7天播放",
          key: "7_view",
          cols: 2,
        },
        {
          label: "人群画像",
          type: "autocompletes",
          key: "persona",
          "item-text": "enum_value",
          "item-value": "enum_value",
          cols: 2,
          items: this.people_portrait_list,
        },
        {
          label: "发布形式",
          type: "autocompletes",
          key: "publish_form",
          "item-text": "label",
          "item-value": "value",
          cols: 2,
          items: publish_form_list,
          change: this.search,
        },

        {
          label: "是否评价",
          type: "autocompletes",
          key: "appraised",
          "item-text": "label",
          "item-value": "value",
          cols: 2,
          items: [
            {
              label: "未选择",
              value: null,
            },
            {
              label: "已评价",
              value: true,
            },
            {
              label: "未评价",
              value: false,
            },
          ],
          change: this.search,
        },

        // {
        //     label: '7天点赞',
        //     key:'7_up',
        //     cols: 3,
        // },
        // {
        //     label: '7天点赞',
        //     key:'7_up',
        //     cols: 3,
        // },
        // {
        //     label: '发布时间-起始',
        //     type: 'month_field',
        //     key: 'publish_at_start',
        //     cols: 2,
        //     'allowed-dates': this.allowedMonthsStart,
        //     clearable:true,
        //     selected_close: true,
        //     'click:clear':this.search,
        //     change:this.search,
        // },
        // {
        //     label: '发布时间-结束',
        //     type: 'month_field',
        //     key: 'publish_at_end',
        //     cols: 2,
        //     'allowed-dates': this.allowedMonthsEnd,
        //     clearable:true,
        //     selected_close: true,
        //     'click:clear':this.search,
        //     change:this.search,
        // },

        {
          label: "",
          "append-icon": "mdi-magnify",
          key: "search",
          cols: 3,
          clearable: true,
          "click:append": this.search,
          "click:clear": this.search,

          "keydown.enter": (e) => {
            e.preventDefault();
            this.search();
          },
        },

        {
          key: "handle",
          cols: 5,
        },
      ];
    },
    search_fields_proxy() {
      return this.search_fields.filter((i) => {
        return this.selected.includes(i.key) || noHandleArray.includes(i.key);
      });
    },
    cur_customer() {
      return this.$store.state.cur_customer;
    },
    is_uda() {
      return (
        this.cur_customer.groups &&
        this.cur_customer.groups.includes("UDA_USER_GROUP")
      );
    },
  },
  created() {
    this.getPeoplePortraitList();
    this.getEnumConfigContentList();
    this.getEnumConfigPlatformList();
    window.addEventListener("setItemEvent", () => {
      setTimeout(() => {
        this.selected = getLocalStorage();
      }, 200);
    });
  },
  methods: {
    inputComponent({ keys, label }) {
      return () => (
        <NumberRange
          v-model={this.params}
          keys={keys}
          label={label}
          on={{
            submit: () => this.search(),
          }}
        />
      );
    },
    changeSearch() {
      //  console.log(this.search_fields.map())
      this.$refs.selected.edit();
    },
    getPeoplePortraitList() {
      getEnumConfigListApi({
        enum_type: "人群画像" + (this.is_uda ? "_UDA" : ""),
        del: false,
      }).then((res) => {
        this.people_portrait_list = res || [];
      });
    },
    getEnumConfigContentList() {
      getEnumConfigListApi({
        enum_type: "内容类别" + (this.is_uda ? "_UDA" : ""),
        del: false,
      }).then((res) => {
        this.content_types = res || [];
      });
    },
    getEnumConfigPlatformList() {
      getEnumConfigListApi({
        enum_type: "平台",
        del: false,
      }).then((res) => {
        this.platform = res || [];
      });
    },
    allowedMonthsStart(val) {
      if (!this.params.publish_at_end) {
        return true;
      }
      return this.params.publish_at_end >= val;
    },
    allowedMonthsEnd(val) {
      if (!this.params.publish_at_start) {
        return true;
      }
      return this.params.publish_at_start <= val;
    },
    getParams() {
      const { put_date_, estimate_publish, ...params } = this.params;
      params.tags = (params.tags && params.tags.join(",")) || undefined;
      const p_hash = {};
      const params_proxy = {};
      this.search_fields_proxy.forEach((item) => {
        p_hash[item.key] = true;
        switch (item.key) {
          case "put_date_":
            p_hash.publish_at_start = true;
            p_hash.publish_at_end = true;
            break;
          case "estimate_publish":
            p_hash.estimate_publish_at_start = true;
            p_hash.estimate_publish_at_end = true;
            break;
          case "7_up":
            p_hash.first_week_like_num_begin = true;
            p_hash.first_week_like_num_end = true;
            break;
          case "7_comment":
            p_hash.first_week_comment_num_begin = true;
            p_hash.first_week_comment_num_end = true;
            break;
          case "7_favorite":
            p_hash.first_week_favorite_num_begin = true;
            p_hash.first_week_favorite_num_end = true;
            break;
          case "7_view":
            p_hash.first_week_view_num_begin = true;
            p_hash.first_week_view_num_end = true;
            break;
          default:
            break;
        }
      });
      Object.keys(params).forEach((key) => {
        if (p_hash[key]) {
          params_proxy[key] = params[key];
        }
      });
      return params_proxy;
    },
    search() {
      this.$nextTick(() => {
        this.$emit("search", this.getParams());
      });
    },
  },
  render() {
    return (
      <div>
        <SearchBar
          fields={this.search_fields_proxy}
          v-model={this.params}
          scopedSlots={{
            handle: () => {
              return (
                <div class={styles["buttons-contain"]}>
                  <VBtn
                    color="primary"
                    on={{
                      click: () => {
                        this.$emit("add");
                      },
                    }}
                  >
                    添加
                  </VBtn>
                  <VBtn
                    color="primary"
                    on={{
                      click: () => {
                        this.$emit("export");
                      },
                    }}
                  >
                    导出EXCEL
                  </VBtn>
                  <VBtn
                    color="primary"
                    on={{
                      click: () => {
                        this.$emit("import");
                      },
                    }}
                  >
                    导入EXCEL
                  </VBtn>
                  <VBtn
                    color="primary"
                    on={{
                      click: () => {
                        this.$emit("pl");
                      },
                    }}
                  >
                    批量操作
                  </VBtn>
                  <VIcon
                    small
                    style="cursor: pointer;"
                    on={{ click: () => this.changeSearch() }}
                  >
                    mdi-wrench
                  </VIcon>
                </div>
              );
            },
            "7_up": this.inputComponent({
              label: "7天点赞数",
              keys: ["first_week_like_num_begin", "first_week_like_num_end"],
            }),
            "7_comment": this.inputComponent({
              label: "7天评论数",
              keys: [
                "first_week_comment_num_begin",
                "first_week_comment_num_end",
              ],
            }),
            "7_favorite": this.inputComponent({
              label: "7天收藏量",
              keys: [
                "first_week_favorite_num_begin",
                "first_week_favorite_num_end",
              ],
            }),
            "7_view": this.inputComponent({
              label: "7天播放量",
              keys: ["first_week_view_num_begin", "first_week_view_num_end"],
            }),
          }}
        />
        <SelectedFields ref="selected" list={this.search_fields} />
      </div>
    );
  },
};
